import { ApplicationRef, Injectable, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { appInjector } from '@max/shared/app-injector';
import { ModalSize } from '@max/shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '@max/shared/services/modal/mvd-modal.service';
import { AppSettings } from '@max/shared/settings/app-settings.model';
import { AuthService } from './auth.service';

@Injectable()
/**
 * Handles any problems with security
*/
export class HttpResponseHandlerService {

    private _router: Router;
    private _viewContainer: ViewContainerRef;
    private _securitySettings: AppSettings.SecuritySettings;
    private accessDeniedModalOpen = false;

    private get viewContainer(): ViewContainerRef {
        if (this._viewContainer == undefined && this.appRef != undefined && this.appRef['_rootComponents']) {
            const rootComponent = this.appRef['_rootComponents'][0];
            if (rootComponent != undefined) {
                const hostElement = rootComponent['_hostElement'];
                if (hostElement != undefined) {
                    this._viewContainer = hostElement.vcRef;
                }
            }
        }
        return this._viewContainer;
    }

    constructor(
        public modalService: MvdModalService,
        private appRef: ApplicationRef,
        private _auth: AuthService
    ) {
        var injector = appInjector();
        const appSettings = <AppSettings> injector.get(AppSettings);

        this._securitySettings = appSettings.security;
    }

    private get router(): Router {
        if (this._router == undefined) {
            var injector = appInjector();
            this._router = <Router> injector.get(Router);
        }
        return this._router;
    }

    public handleServiceStatus(statusCode, err) {

        // Redirects for 503 errors
        if (statusCode == 503) {
            if (this._securitySettings.httpStatusCodeRedirects != undefined && this._securitySettings.httpStatusCodeRedirects != null) {
                const redirectResults = this._securitySettings.httpStatusCodeRedirects.filter(f => f.statusCode == statusCode);
                if (redirectResults != undefined && redirectResults.length > 0) {
                    const redirect = redirectResults[0];
                    this.router.navigate([redirect.redirectUrl]);
                    this.modalService.closeAll();
                }
            }
        }

        if (typeof err === 'string' && err.indexOf('Invalid Security Stamp') > 0) {
            console.log('Logging you out due to the BAD SECURITY STAMP', err);
            console.log('Logging you out due to the BAD SECURITY STAMP - Token', this._auth.accessToken);
            this._auth.logOut();
        }

        // find status code and redirect correctly unless it doesn't exist, in which case default to home page
        if (this._securitySettings != undefined) {
            if (this._securitySettings.httpStatusCodeRedirects != undefined && this._securitySettings.httpStatusCodeRedirects != null) {
                const redirectResults = this._securitySettings.httpStatusCodeRedirects.filter(f => f.statusCode == statusCode);
                if (redirectResults != undefined && redirectResults.length > 0) {
                    const redirect = redirectResults[0];
                    if (redirect.accessDenied && !this.accessDeniedModalOpen) {
                        this.accessDeniedModalOpen = true;
                        this.displayAccessDenied();
                        this.router.navigate(['/auth/bu']);
                    }
                    if (this._auth.validUser && !this._auth.hasBusinessUnitAccess) {
                        this._auth.selectBusinessUnit();
                    } else if (!this.accessDeniedModalOpen) {
                        this.router.navigate([redirect.redirectUrl]);
                    }
                    return;
                }
            }
        }
    }

    public displayAccessDenied(message?: string) {
        this.modalService.alert().body(message || 'You do not have sufficient rights to access the selected resource.')
            .title('Access Denied').okBtn('OK').open(ModalSize.Small)
            .afterClosed()
            .subscribe(() => this.accessDeniedModalOpen = false);
    }

}
